import { render, staticRenderFns } from "./PostViewVo.vue?vue&type=template&id=f0c95304&"
import script from "./PostViewVo.vue?vue&type=script&lang=js&"
export * from "./PostViewVo.vue?vue&type=script&lang=js&"
import style0 from "./PostViewVo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports